module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-dc3fa5415df734a788a55f152e463282.svg";